import type { EvalSuiteSpec } from '@sbc/domain-models/agents';
import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import { ApiError } from '@/lib/api/client';
import { useCreateEvalSuite } from '@/lib/api/eval-suites';

import { SuiteForm } from './suite-form';

export function SuiteNewPage() {
  const navigate = useNavigate();
  const createSuite = useCreateEvalSuite();
  const [error, setError] = useState<string | null>(null);

  const onSubmit = (spec: EvalSuiteSpec) => {
    setError(null);
    createSuite.mutate(spec, {
      onSuccess: (suite) =>
        navigate({ to: '/evals/suites/$suiteId', params: { suiteId: suite.id } }),
      onError: (caught) =>
        setError(caught instanceof ApiError ? caught.message : 'Could not create the suite.'),
    });
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">New eval suite</h1>
      <SuiteForm
        submitting={createSuite.isPending}
        submitLabel="Create suite"
        error={error}
        onSubmit={onSubmit}
        onCancel={() => navigate({ to: '/evals/suites' })}
      />
    </div>
  );
}
